export default __webpack_public_path__ + "locales/fr/PrivacyPage.json?hash=c165a0aa948f2a6bc5415e81409b8656";